import { xs_languageCode } from "..";
import { getPlayabilityClasses } from './utils/getPlayabilityClasses';
import { getSplitDesc } from './utils/getSplitDesc';
import { oddToString } from './utils/oddToString';

export function addOddsValuesToBet(matchData, betData, bet, odds) {   
    betData.eqs.forEach(e => {
        e.d = e.dsl?.[xs_languageCode] ?? null;
    });
    // MODELLI SCOMMESSA A LISTA (da Aggregata esiti � SEMPRE vuoto)        
    if (bet.odds.length === 0) {
        const oddBetData = {
            aggDesc: bet.aggDesc,
            aggId: bet.aggId,
            calculateHandicapDescription: bet.calculateHandicapDescription,
            desc: bet.desc,
            dia: betData.dia,
            eqs: betData.eqs,
            handicap: bet.handicap,
            handicapInfo: bet.handicapInfo,
            hideHandicap: bet.hideHandicap,
            id: bet.id,
            isLive: matchData.isLive,
            legabile: bet.legabile,
            maxg: betData.maxg,
            ming: betData.ming,
            parametrica: bet.parametrica,
            pClass: getPlayabilityClasses(betData.ming, betData.maxg),
            tipoHandicap: bet.tipoHandicap
        };
        const [team1, team2] = getSplitDesc(matchData.desc);
        
        bet.forceOddsListColumn = true;
        bet.hasOddTooltips = false;
        bet.odds = odds.filter(o => o.q > 0).sort((a, b) => a.q - b.q).map(odd => {
            if (!bet.hasOddTooltips && odd.tooltip?.length > 0) {
                bet.hasOddTooltips = true;
            }
          
            return {
                alias: "",
                betData: oddBetData,
                betId: bet.id,
                desc: odd.d,
                id: odd.ce,
                matchData,
                ranking: 0,                    
                rawValue: odd.q > 100 ? odd.q : null,
                team1,
                team2,
                uniqueId: `${matchData.uniqueId}_${bet.id}_${bet.handicap}_${odd.ce}`,
                value: oddToString(odd.q)
            };
        });
        
        return;
    }
    
    if (bet.tipoHandicap === 7) {
        const oddById = new Map();
        bet.odds.forEach(o => oddById.set(o.id, o));
        
        betData.eqs.forEach(e => {
            if (oddById.has(e.ce)) {
                oddById.get(e.ce).desc = e.d;
            }
        });
    }
    
    const oddBetData = {
        aggDesc: bet.aggDesc,
        aggId: bet.aggId,
        calculateHandicapDescription: bet.calculateHandicapDescription,
        desc: (bet.tipoHandicap === 6 && bet.aggId > 0) ? bet.aggDesc : bet.desc,
        dia: betData.dia,
        eqs: betData.eqs,
        handicap: bet.handicap,
        handicapInfo: bet.handicapInfo,
        hideHandicap: bet.hideHandicap,
        id: bet.id,
        isLive: matchData.isLive,
        legabile: bet.legabile,
        maxg: betData.maxg,
        ming: betData.ming,
        parametrica: bet.parametrica,
        pClass: getPlayabilityClasses(betData.ming, betData.maxg),
        tipoHandicap: bet.tipoHandicap,
        statsInfo: bet.s ? bet.s : null
    };
    const [team1, team2] = getSplitDesc(matchData.desc);

    const oddById = new Map();
    odds.forEach(odd => oddById.set(odd.ce, odd));

    // Aggiungo i valori delle quote alla scommessa
    bet.hasOddTooltips = false;
    bet.odds = bet.odds.map(odd => {
        if (!bet.hasOddTooltips && odd.tooltip?.length > 0) {
            bet.hasOddTooltips = true;
        }

        const value = oddById.get(odd.id)?.q ?? 0;
        return {
            ...odd,
            uniqueId: `${matchData.uniqueId}_${bet.id}_${bet.handicap}_${odd.id}`,
            rawValue: value > 100 ? value : null,
            value: oddToString(value),
            matchData,
            betData: oddBetData,
            team1,
            team2
        };
    });
}
